import type { BrandShellConfig } from "../base/BrandShell";

import { GuestmakerLogo } from "./GuestmakerLogo";
import { GUESTMAKER_PROOFS } from "./proofs";

/**
 * Where the "not signed in" exit leads. Absolute, and www: this page is served
 * from the Auth0 domain, so a relative href would resolve against it, and the
 * apex redirects to www anyway.
 */
export const MARKETING_SITE_URL = "https://www.guestmaker.ai/";

// Inline SVG turbulence noise; opacity/blend applied in CSS.
// `<`/`>` and the literal `%` in `100%` are percent-encoded (%3C/%3E/%25) so the
// data URI stays valid; `%23n` (the `#n` fragment reference) is already encoded.
const GRAIN =
  "url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

/** GuestMaker: fuchsia/pink/violet aurora on near-black, light form only. */
export const GUESTMAKER_SHELL: BrandShellConfig = {
  testId: "gm-shell",
  art: (
    <>
      <div className="gm-aurora" aria-hidden="true">
        <div className="gm-aurora__blob gm-aurora__blob--fuchsia" />
        <div className="gm-aurora__blob gm-aurora__blob--pink" />
        <div className="gm-aurora__blob gm-aurora__blob--violet" />
      </div>
      <div
        className="gm-grain"
        aria-hidden="true"
        style={{ backgroundImage: GRAIN }}
      />
    </>
  ),
  logo: (compact) => <GuestmakerLogo tone="light" height={compact ? 56 : 96} />,
  eyebrow: "GUESTMAKER",
  proofs: GUESTMAKER_PROOFS,
  home: { href: MARKETING_SITE_URL, label: "Back to guestmaker.ai" },
};
